import Navbar from "./Navbar";
import Main from "./Main";
import { Route, Routes } from "react-router-dom";
import LeaderboardPage from "./LeaderboardPage";
import { useEffect, useState } from "react";
import { AppContext } from "./global/context";
import { fetchData } from "./global/api";

function App() {
  const [state, setState] = useState(/** @type {import("./context").AppState} */ (null));

  useEffect(() => {
    (async () => {
      try {
        const data = await fetchData();
        setState(data);
      } catch (error) {
        console.error(error);
        alert("An error occured!");
      }
    })();
  }, []);

  return (
    <AppContext.Provider value={state}>
      <Navbar />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/leaderboard" element={<LeaderboardPage />} />
        <Route path="/*" element={<div>404</div>} />
      </Routes>
    </AppContext.Provider>
  );
}

export default App;
